exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-group-control .card-title>a.collapsed[data-v-fd08f306]:before{content:\"\\E9CA\"!important;content:\"\\E9B8\"}.card-group-control .card-title>a[data-v-fd08f306]:before{content:\"\\E9C9\"!important}.daylink[data-v-fd08f306]:before{left:0!important}.alternating tr[data-v-fd08f306]{border-top:1px solid #ccc}.alternating tr[data-v-fd08f306]:first-child{border-top:1px solid #fff}.custom-table-text[data-v-fd08f306]{font-size:14px;height:40px}.smaller-text[data-v-fd08f306]{font-size:12px}@media screen and (max-width:768px){.custom-table-text[data-v-fd08f306]{font-size:10px}}.select_container[data-v-fd08f306]{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fd08f306","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shift/location-shift-new.vue
// module id = 1085
// module chunks = 0